import type { ReactNode } from 'react';
import { IconX } from '@tabler/icons-react';
import '@/styles/member.css';

export interface NudgeCardProps {
  /** 22 to 24 px Tabler icon, shown in a soft tile. */
  icon: ReactNode;
  title: ReactNode;
  children?: ReactNode;
  /** One or two buttons (48 px). */
  action?: ReactNode;
  /** warn = something is needed before the member can continue; info = a friendly suggestion. */
  tone?: 'info' | 'warn' | 'bad';
  /** Shows a 48 px "hide" button. */
  onDismiss?: () => void;
  dismissLabel?: string;
  /** Heading level for the title (h2 on Home, h3 inside a section). */
  headingLevel?: 2 | 3;
  /** No card chrome (inside a SectionCard). */
  flat?: boolean;
  ariaLabel?: string;
}

/**
 * One "to do" card: icon, a short title, one sentence and one action. Home shows at most one at a
 * time, the most important first (documents, driver checks, photo, alerts).
 */
export function NudgeCard({ icon, title, children, action, tone = 'info', onDismiss, dismissLabel = 'Hide this', headingLevel = 2, flat, ariaLabel }: NudgeCardProps) {
  const H = headingLevel === 3 ? 'h3' : 'h2';
  return (
    <section className={`rm-nudge ${tone}${flat ? ' flat' : ''}`} aria-label={ariaLabel}>
      <span className="ic" aria-hidden="true">{icon}</span>
      <div className="body">
        <H>{title}</H>
        {children && <p>{children}</p>}
        {action && <div className="act">{action}</div>}
      </div>
      {onDismiss && (
        <button type="button" className="rides-iconbtn x" onClick={onDismiss} aria-label={dismissLabel}>
          <IconX size={20} aria-hidden="true" />
        </button>
      )}
    </section>
  );
}
